import { lazy, Suspense } from "react";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import Loader from "../components/Loader/Loader.jsx";
import config from '../config/config.js';
import Login from "../pages/Login/Login.jsx";
import ActivateAccount from "../pages/ActivateAccount/ActivateAccount.jsx";
import ForgotPassword from "../pages/ForgotPassword/ForgotPassword.jsx";
import ResetPassword from "../pages/ResetPassword/ResetPassword.jsx";
import NotFound from "../pages/NotFound/NotFound.jsx";
import { RequirePermission } from "./guards/RequirePermission.jsx";

const LayoutPrivadas = lazy(() => import("../layouts/LayoutPrivadas/LayoutPrivadas.jsx"));

const routesConfig = [
    { path: "locaciones", component: lazy(() => import('../pages/Locaciones/Locaciones.jsx')) },
    { path: "agenda", component: lazy(() => import('../pages/Agenda/Agenda.jsx')) },
    { path: "configuraciones", component: lazy(() => import('../pages/Configuraciones/Configuraciones.jsx')) },
    { path: "turnos", component: lazy(() => import('../pages/Turnos/Turnos.jsx')) },
    { path: "reportes", component: lazy(() => import("../pages/Reportes/Reportes.jsx")) },
    { path: "usuarios", component: lazy(() => import('../pages/Usuarios/Usuarios.jsx')) },
    { path: "auditoria", component: lazy(() => import('../pages/Auditoria/Auditoria.jsx')) },
];

export default function Rutas() {
    return (
        <BrowserRouter basename={config.URL.BASENAME}>
            <Suspense fallback={<Loader />}>
                <Routes>
                    <Route path="/login" element={<Login />} />
                    <Route path="/activate-account/:hash" element={<ActivateAccount />} />
                    <Route path="/reset-password/:hash" element={<ResetPassword />} />
                    <Route path="/forgot-password/" element={<ForgotPassword />} />
                    <Route path="/" element={<LayoutPrivadas />}>
                        <Route path="*" element={<NotFound />} />
                        {routesConfig.map(({ path, component: Component }) => (
                            <Route
                                key={path}
                                path={path}
                                element={
                                    <RequirePermission
                                        permissions={[path]}
                                        fallback={<Navigate to="/" replace />}
                                    >
                                        <Component />
                                    </RequirePermission>
                                }
                            />
                        ))}
                    </Route>
                </Routes>
            </Suspense>

            <ToastContainer
                position="top-right"
                autoClose={3000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
            />
        </BrowserRouter>
    );
}
